module.exports = __webpack_public_path__ + "img/google-analytics.3fc253a7.svg";